import { Injectable, Output, EventEmitter } from '@angular/core';
// import { Subject } from 'rxjs/Subject';

@Injectable({
  providedIn: 'root'
})
export class ScssThemeChangeService {
    // private _darkTheme = new Subject<boolean>();
    // isDarkTheme = this._darkTheme.asObservable();
    user_app_id: string = 'night';
    private change_theme_emitter: EventEmitter<string> = new EventEmitter();

    switchTheme(user_app_id: string) {
        this.change_theme_emitter.emit(user_app_id);
    }

    getThemeEmitter():EventEmitter<string>{
        return this.change_theme_emitter;
    }

    setDarkTheme(isDarkTheme: boolean): void {
      // this._darkTheme.next(isDarkTheme);
    }

    constructor() { }
}

/*
*
* let subject = new Subject<string>();

 subject.subscribe((data) => {
 });subject.subscribe((data) => {
 });

 subject.next("Eureka");
*
*
* */
